const Counters = () => {
	const counters = document.getElementsByClassName("counters")[0];
	const countersElements = document.getElementsByClassName(
		"counters__wrapper-item-number"
	);
	const body = document.getElementsByTagName("body")[0];

	if (counters) {
		var executed = false;
		function countNumbers() {
			if (!executed) {
				executed = true;
				Array.prototype.forEach.call(countersElements, function (node) {
					var counter = 0;
					var speed = 0;
					if (node.dataset.number < 10) {
						speed = 80;
					} else if (node.dataset.number > 10 && node.dataset.number < 50) {
						speed = 50;
					} else if (node.dataset.number > 50 && node.dataset.number < 200) {
						speed = 5;
					} else {
						speed = 1;
					}
					var interval = setInterval(function () {
						if (counter == node.dataset.number) clearInterval(interval);
						node.innerHTML = counter;
						counter += node.dataset.number >= 1000 ? 10 : 1;
					}, speed);
				});
			}
		}

		// BEGIN: ed8c6549bwf9
		const options = {
			root: null,
			rootMargin: "0px",
			threshold: 0.2, // Adjust this threshold value as per your requirement
		};

		const observer = new IntersectionObserver(function (entries, observer) {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					countNumbers();
					observer.unobserve(entry.target);
				}
			});
		}, options);

		observer.observe(counters);
		// END: ed8c6549bwf9
	}
};

export default Counters;
